import type { SVGProps } from "react";

export const GavelIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 21h12v2H1v-2zm16.59-12.41l-4.24-4.24-2.83 2.83 4.24 4.24 2.83-2.83zM13.35 6.76l-1.41-1.41-6.36 6.36 1.41 1.41 6.36-6.36zm6.36 6.36l-4.24-4.24-2.83 2.83 4.24 4.24 2.83-2.83z" />
    </svg>
  );
};
